/**
 * Error handling utilities for API responses
 */

export interface ApiError {
  code: string
  message: string
  message_th?: string
  suggestion?: string
}

export interface ApiErrorResponse {
  success: false
  error: ApiError
  message: string
  timestamp: string
  request_id?: string
}

/**
 * Extract error message from API response
 */
export const getErrorMessage = (error: any): string => {
  // If it's an axios error with response
  if (error?.response?.data) {
    const apiError = error.response.data as ApiErrorResponse
    
    // Return Thai message if available, otherwise English
    return apiError.error?.message_th || apiError.error?.message || apiError.message || 'เกิดข้อผิดพลาด'
  }
  
  // Network or other errors
  if (error?.message) {
    return error.message
  }
  
  return 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ'
}

/**
 * Check if error is authentication related
 */
export const isAuthError = (error: any): boolean => {
  return error?.response?.status === 401 || 
         error?.response?.data?.error?.code === 'UNAUTHORIZED'
}

/**
 * Check if error is network related
 */
export const isNetworkError = (error: any): boolean => {
  return !error?.response || error?.code === 'NETWORK_ERROR'
}

/**
 * Get user-friendly error message with suggestions
 */
export const getErrorWithSuggestion = (error: any): { message: string, suggestion?: string } => {
  const apiError = error?.response?.data as ApiErrorResponse
  
  if (apiError?.error) {
    return {
      message: apiError.error.message_th || apiError.error.message,
      suggestion: apiError.error.suggestion
    }
  }
  
  // Handle common error types
  if (isNetworkError(error)) {
    return {
      message: 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
      suggestion: 'กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ตและลองใหม่อีกครั้ง'
    }
  }
  
  if (isAuthError(error)) {
    return {
      message: 'การเข้าสู่ระบบหมดอายุ',
      suggestion: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง'
    }
  }
  
  return {
    message: getErrorMessage(error)
  }
}